/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CnsLog request payload
 * @export
 * @interface CnsLogRequest
 */
export interface CnsLogRequest {
    /**
     * 
     * @type {string}
     * @memberof CnsLogRequest
     */
    operationType?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogRequest
     */
    requestContent?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogRequest
     */
    responseContent?: string;
    /**
     * 
     * @type {string}
     * @memberof CnsLogRequest
     */
    status?: string;
    /**
     * 
     * @type {Date}
     * @memberof CnsLogRequest
     */
    timestamp?: Date;
    /**
     * 
     * @type {number}
     * @memberof CnsLogRequest
     */
    financialGroupId?: number;
    /**
     * 
     * @type {string}
     * @memberof CnsLogRequest
     */
    personWithRoleCounterParty?: string;
}

/**
 * Check if a given object implements the CnsLogRequest interface.
 */
export function instanceOfCnsLogRequest(value: object): value is CnsLogRequest {
    return true;
}

export function CnsLogRequestFromJSON(json: any): CnsLogRequest {
    return CnsLogRequestFromJSONTyped(json, false);
}

export function CnsLogRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CnsLogRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operationType': json['operationType'] == null ? undefined : json['operationType'],
        'requestContent': json['requestContent'] == null ? undefined : json['requestContent'],
        'responseContent': json['responseContent'] == null ? undefined : json['responseContent'],
        'status': json['status'] == null ? undefined : json['status'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
        'financialGroupId': json['financialGroupId'] == null ? undefined : json['financialGroupId'],
        'personWithRoleCounterParty': json['personWithRoleCounterParty'] == null ? undefined : json['personWithRoleCounterParty'],
    };
}

export function CnsLogRequestToJSON(json: any): CnsLogRequest {
    return CnsLogRequestToJSONTyped(json, false);
}

export function CnsLogRequestToJSONTyped(value?: CnsLogRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operationType': value['operationType'],
        'requestContent': value['requestContent'],
        'responseContent': value['responseContent'],
        'status': value['status'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
        'financialGroupId': value['financialGroupId'],
        'personWithRoleCounterParty': value['personWithRoleCounterParty'],
    };
}

